import http from './http';
import config from '~/config';

const endpoint = `${config.urls.base}/metrics`;

export const policySearchCountsByUser = async (userId, backDate = null) => {
    if (userId) {
        const uri = `${endpoint}/${userId}/policySearch`;

        const response = await http.get2(uri, { backDate });
        if (response.errored)
            throw new Error(response.error);
        return response;
    }
    else {
        const uri = `${endpoint}/policySearch`;

        const response = await http.get2(uri, { backDate });
        if (response.errored)
            throw new Error(response.error);
        return response;
    }
};


export const titleOpinionCountsByUser = async (userId, backDate = null) => {
    const uri = `${endpoint}/${userId}/titleOpinion`;

    const response = await http.get2(uri, { backDate });
    if (response.errored)
        throw new Error(response.error);
    return response;
};

export default {
    policySearchCountsByUser,
    titleOpinionCountsByUser
};